export default "__VITE_ASSET__CyWG4GCz__"